
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/braze",
      function () {
        return require("private-next-pages/destinations/braze.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/braze"])
      });
    }
  